import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const VerifyEmailModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "VerifyEmailModalContainer" */
      './VerifyEmailModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
